/**
 * @file step
 * @author zhaomiaoyuan
 */
import React from 'react';
// import {withRouter} from 'react-router';
// import PropTypes from 'prop-types';
// import {Button} from 'antd';

const VerifySelf = () => {
    return (
        <div className="verify-msg-self">
            <div className="verify-main-content">
                功能升级中，您可以发送邮件至haomakefu@baidu.com进行咨询修改
            </div>
        </div>
    );
};

export default VerifySelf;